import { useEffect } from 'react';
import Raven from 'raven-js';

import { useGetAppIdsQuery } from '../../__generated__/chirp/com/hubspot/dashworks/rpc/DashworksRpc.hooks';

type TUseDashworksAppIdsArgs = {
  skip?: boolean;
};

export const useDashworksAppIds = (args?: TUseDashworksAppIdsArgs) => {
  const { data, loading, error, networkStatus } = useGetAppIdsQuery({
    skip: args?.skip ?? false,
  });

  useEffect(() => {
    if (error) {
      Raven.captureException(error);
    }
  }, [error]);

  return {
    data: data?.appIds || ([] as number[]),
    isLoading: loading,
    error: error || null,
    networkStatus,
  };
};
